import React, { useEffect, useState, forwardRef } from "react";
import { Col, Row } from "react-bootstrap";
import { Divider, QRCode, Image, Space } from "antd";
import { ArrowBarUp } from "react-bootstrap-icons";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Card = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var candidat = _ref.candidat;
  return /*#__PURE__*/_jsxs("div", {
    ref: ref,
    id: "printable",
    style: {
      width: "495px",
      height: "312px",
      clear: "both",
      borderRadius: "0px",
      padding: "25px",
      color: "#010101",
      background: "#FFFFFF"
    },
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        "float": "left",
        width: "40%"
      },
      children: [/*#__PURE__*/_jsx(QRCode, {
        color: "#010101",
        value: "https://patient.medvitale.app/#/scanpatientcode/" + encodeURIComponent(candidat.candidate_code)
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          textAlign: "center"
        },
        children: [/*#__PURE__*/_jsx(ArrowBarUp, {
          color: "#010101",
          size: 24
        }), /*#__PURE__*/_jsx("div", {
          style: {
            color: "#010101"
          },
          children: "Scannez ici"
        })]
      }), /*#__PURE__*/_jsx("br", {})]
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        "float": "right",
        width: "60%"
      },
      children: [/*#__PURE__*/_jsx(Image, {
        src: "drawables/4.png",
        width: "220px",
        preview: false
      }), /*#__PURE__*/_jsx("br", {})]
    }), /*#__PURE__*/_jsx("div", {
      style: {
        clear: "both",
        color: "#010101",
        borderTop: "1px dashed #010101"
      },
      children: /*#__PURE__*/_jsx("b", {
        children: "".concat(candidat.name)
      })
    }), /*#__PURE__*/_jsx("br", {})]
  });
});
export default Card;